import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { Home, Menu } from "lucide-react";

export default function Layout() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Body scroll kilidi
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [sidebarOpen]);

  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* İçerik */}
      <div className="flex-1 lg:ml-64 bg-gray-100 flex flex-col relative">
        {/* Üst barı kaldırdık → sadece hamburger butonu mobilde gözüksün */}
        <div className="p-4 lg:hidden flex items-center justify-between">
          {/* Hamburger butonu (sadece mobilde) */}
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-gray-700"
          >
            <Menu size={24} />
          </button>
        </div>

        {/* Sağ üstte sabit “Ana Sayfaya Dön” */}


        {/* Sayfa içeriği */}
        <div className="flex-1 p-6 mt-12">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
